<template>
  <div
    class="DebugControls"
  >
    <div>
      <button
        :disabled="currentQuestion === 0"
        class="button m-r-md"
        @click="decrementQuestion"
      >
        Back
      </button>
    </div>

    <label>
      Current Q: {{ currentQuestion }}
    </label>

    <div class="control is-ho">
      <label>Go to Q</label>
      <input
        type="number"
        class="input"
        min="0"
        :max="questionsLength - 1"
        @change="changeQuestion"
      >
    </div>

    <div>
      <button
        :disabled="currentQuestion >= (questionsLength - 1)"
        class="button"
        @click="incrementQuestion"
      >
        Forward
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentQuestion: {
      type: Number,
      default: 0,
    },
    questionsLength: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {};
  },

  computed: {},

  methods: {
    changeQuestion(event) {
      const newQuestion = +event.target.value;
      if (newQuestion > (this.questionsLength - 1) || newQuestion < 0) return;

      this.$emit('debug-controls:change-question', newQuestion);
    },
    incrementQuestion() {
      this.$emit('debug-controls:change-question', this.currentQuestion + 1);
    },
    decrementQuestion() {
      this.$emit('debug-controls:change-question', this.currentQuestion - 1);
    },
  },
};
</script>

<style scoped lang="scss">

.DebugControls {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
  background-color: rgba(255,255,255,0.6);
  padding: 10px;
}
</style>
